import menuIcon from "../../../assets/menuIcon.png";
import payments from "../../../assets/payments.png";
import paymentMethods from "../../../assets/payment_methods.png";
import { useTranslation } from "react-i18next";
import FeedBack from "../../../components/feedback";

function AddPayment() {
  const { t } = useTranslation();

  return (
    <article>
      <h1 className="text-xl md:text-2xl font-bold dark:text-secondaryGreen">
        {t("helpCenter.sidebar.How do I add a payment account?")}
      </h1>
      <div className="w-full h-[1px] bg-[#eff2f5] dark:bg-[#303032] mt-4 "></div>
      <section className="mt-8">
        <p className="mb-2">
          <span className="font-semibold">Step 1: </span>
          {t("helpCenter.General.addPayments.step1.part1")}
          <img src={menuIcon} alt="icon" className="inline-flex" />{" "}
          {t("helpCenter.General.addPayments.step1.part2")}
          <img src={payments} alt="icon" className="inline-flex h-7 w-7" />{" "}
          {t("helpCenter.General.addPayments.step1.part3")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 2: </span>
          {t("helpCenter.General.addPayments.step2.part1")}
          <img
            src={paymentMethods}
            alt="icon"
            className="inline-flex h-9 w-10"
          />{" "}
          {t("helpCenter.General.addPayments.step2.part2")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 3: </span>
          {t("helpCenter.General.addPayments.step3")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 4: </span>
          {t("helpCenter.General.addPayments.step4")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 5: </span>
          {t("helpCenter.General.addPayments.step5")}
        </p>
      </section>
      <FeedBack />
    </article>
  );
}

export default AddPayment;
